import React from 'react';

import '../../css/toggle.less';
import classnames from 'classnames';

/**
 * @param {Boolean} isOn
 * @param {Function} onChange
 * @param {String} className
 * @description Creates a toggle on/off switch
 */
const Toggle = ({ isOn = false, onChange = () => {}, className = '' }) => {

    const classes = classnames({
        toggle: true,
        [className]: true,
        'is-on': isOn,
    });

    return (
        <span 
            role="checkbox"
            tabIndex="0"
            aria-checked={isOn}
            className={classes}
            onClick={event => onChange({ isOn: !isOn, event })}
            onKeyUp={
                event => event.keyCode === 32 ? onChange({ isOn: !isOn, event }) : undefined
            }
        />
    );
};

export default Toggle;
